import React, { useState, useEffect, useMemo, useRef } from "react";
import { SimpleLoading, PromotionalFooterPure, HeaderHLPure, DialogSystemGLPure, ButtonHLPure, GridSelectionHLPure, ButtonAddHLPure, DialogPdfHLPure, InputFileHLPure, DialogPdf, InputHLPure, ChatBoxGLPure, PanelBarGLPure } from "../../pures";
import { AssembliesService, LocalStorageService } from "../../../services";
import { ArrowBtnMobile, newProfileIcon } from "../../../assets/logos/icons";
import { useMediaQuery } from "@material-ui/core";
import { convertToStandarDate, PDFUtil } from "../../../utils";
import { b64toBlob, ProfileValidator } from "../../../validators";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Grid } from '@material-ui/core'
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import moment from 'moment';
import './manage-assembly.view.css';

const HeaderColumns = (props) => {
    return <span className={(props.title === props.t("manageAssemblyView.grid.title.1")) ? "grid-header-one" : "grid-headers"}>{props.title}</span>;
};

const CellColumnDocument = (props) => {
    return (
        <td className="manageAssemblyView-grid-col1">
            <div className='grid-cell-double-container-margin-left'>
                <p className='grid-cell-titles'>{props.dataItem.name}</p>
                <p className='grid-cell-subtitles'>{props.dataItem.dateFormatted}</p>
            </div>
        </td>
    )
}

const CellColumnStatus = (props) => {
    return (
        <td className="manageAssemblyView-grid-col2">
            <div>
                <p className="grid-cell-subtitles">{props.dataItem.status}</p>
            </div>
        </td>
    );
};

const CellColumnBtns = (props) => {
    const ActionButton = () => {
        if (props.statusWorkflow === 316160) return null
        let text = props.dataItem.url ? props.t("manageAssemblyView.grid.btns.view.document") : props.t("manageAssemblyView.grid.btns.view.upload-document")
        const handleFunction = () => {
            if (props.dataItem.url) {
                props.handleViewDoc(props.dataItem)
            } else if (props.statusWorkflow !== 316160) {
                props.setDocumentSelected(props.dataItem)
                props.openModalUpload()
            }
        }
        return (
            <>
                <button className="grid-btn-action" onClick={handleFunction}>
                    <p>{text}</p>
                </button>
            </>
        )
    }

    return (
        <td className="manageAssemblyView-grid-col3">
            <div className="grid-btn-div">
                <ActionButton {...props} />
            </div>
            <div className="grid-btn-arrow" onClick={() => props.handleViewDoc(props.dataItem)}>
                <img alt="assemblies-arrow" src={ArrowBtnMobile} />
            </div >
        </td>
    );
};

const ManageAssemblyView = (props) => {
    let {
        t,
        titleHeader,
        isLoadingView,
        showLoadingRequesting,
        showCompletedRequesting,
        showErrorRequesting,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        toggleErrorRequestingFalse,
        toggleErrorRequesting,
        messageComplete,
        messageError,
        membersChat,
        usersChat,
        conversation,
        createMessage,
        handleInputChangeChat,
        handleBackPage,
        documents,
        selectedFile,
        selectedFileName,
        selectedFileBase64,
        errorFile,
        handleFile,
        handleDeleteFile,
        setDocuments,
        assemblyId
    } = props

    const validator = ProfileValidator(t)

    const preferredLanguage = LocalStorageService.retrieveItem("preferredLanguage")
    const language = preferredLanguage || "es"
    moment.locale(language);

    const is820 = useMediaQuery("(max-width:820px)");
    const mobileResolution = useMediaQuery("(max-width:560px)");
    const is640 = useMediaQuery("(max-width:640px)");
    const is540 = useMediaQuery("(max-width:540px)");

    let ENV = process.env

    const [documentsGrid, setDocumentsGrid] = useState([])
    const [showModalUpload, setShowModalUpload] = useState(false)
    const [documentSelected, setDocumentSelected] = useState(null)
    const [blobUrl, setBlobUrl] = useState("");
    const [showPdfPrincipal, setShowPdfPrincipal] = useState(true)
    const [newDocumentname, setNewDocumentName] = useState('')
    const [showPdfLocal, setShowPdfLocal] = useState(false)
    const [urlBase64, setUrlBase64] = useState('')
    const [errorName, setErrorName] = useState('')
    const pdfRef = useRef(null)
    const [pdfURL, setPdfURL] = useState(`${ENV.REACT_APP_AWS_S3_BUCKET_URL}${ENV.REACT_APP_DEFAULT_PDF}`)

    const pdfAws = useMemo(() => <PdfReader className="pdfReader" url={pdfURL} awsURL src={pdfURL}  ></PdfReader>, [pdfURL])
    const pdf = useMemo(() => <PdfReader className="pdfReader" file={urlBase64} isFile src={`data:application/pdf;base64,${urlBase64}`}  ></PdfReader>, [selectedFileBase64])
    const pdfModal = useMemo(() => <PdfReader className="pdfReader" file={selectedFileBase64} isFile src={`data:application/pdf;base64,${selectedFileBase64}`}  ></PdfReader>, [selectedFileBase64])

    useEffect(() => {
        if (documents && !documents.length) return
        setDocumentsGrid(documents)
        if (documents.length > 0 && documents[0].url) {
            setPdfURL(documents[0].url)
        }
    }, [documents])

    useEffect(() => {
        if (selectedFileBase64) {
            const blob = b64toBlob(selectedFileBase64, "application/pdf");
            setBlobUrl(blob);
        }
    }, [selectedFileBase64]);

    let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
    let CellColumnOne = (props) => <CellColumnDocument {...props} t={t} />
    let CellColumnTwo = (props) => <CellColumnStatus {...props} t={t} />
    let CellColumnThree = (props) => <CellColumnBtns
        {...props}
        t={t}
        setDocumentSelected={setDocumentSelected}
        openModalUpload={openModalUpload}
        pdfRef={pdfRef}
        handleViewDoc={handleViewDoc}
        handleUploadDocument={handleUploadDocument}
    />

    const openModalUpload = () => {
        setShowPdfPrincipal(false)
        setShowModalUpload(true)
    }

    const closeModalUpload = () => {
        handleDeleteFile()
        setNewDocumentName('')
        setErrorName(false)
        setDocumentSelected(null)
        setShowPdfPrincipal(true)
        setShowModalUpload(false)
    }

    /**
     */
    const handleUploadDocument = async () => {
        if (!selectedFile) return
        setShowModalUpload(false)
        toggleLoadingRequesting(true)

        let documentsGridCopy = [...documentsGrid]
        let file = selectedFile
        let dateFormatted = convertToStandarDate(moment(new Date()).toDate(), language)
        try {
            const { base64, error, errorMessage } = await PDFUtil.getPdfBase64(file)
            if (error) throw new Error(errorMessage)

            if (documentSelected && documentSelected.id) {
                const uploadDocument = await AssembliesService.uploadDocumentAssembly(file, assemblyId, documentSelected.id, LocalStorageService.retrieveToken())
                if (uploadDocument.statusCode !== 200) throw new Error(uploadDocument.message)

                const document = documentsGridCopy.find(doc => doc.id === documentSelected.id)
                if (document) {
                    document.url = base64
                    document.status = t("manageAssemblyAction.status.saved")
                }
            } else {
                const uploadDocument = await AssembliesService.uploadDocumentAssembly(file, assemblyId, null, LocalStorageService.retrieveToken(), newDocumentname)
                if (uploadDocument.statusCode !== 200) throw new Error(uploadDocument.message)

                documentsGridCopy.push({
                    id: uploadDocument.data.id,
                    name: newDocumentname,
                    status: t("manageAssemblyAction.status.saved"),
                    dateFormatted,
                    url: uploadDocument.data.documentUrl
                })
            }
            toggleLoadingRequesting(false)
            toggleCompletedRequesting(3000)

            setUrlBase64(selectedFileBase64)
            setErrorName(false)
            setShowPdfLocal(true)
            setDocumentsGrid(documentsGridCopy)
            handleDeleteFile()
            setNewDocumentName('')
            setShowPdfPrincipal(true)
        } catch (e) {
            toggleLoadingRequesting(false)
            toggleErrorRequesting(e.message, 3000)
        }
    }

    let heightContainerModal = mobileResolution ? 350 : 800
    let widthContainerModal = mobileResolution ? 550 : 770
    let heightBodyModal = mobileResolution ? 230 : 620

    const handleChangeInput = (e, setValue, setError) => {
        let value = e.target.value
        setValue(value)
        setError(false)
    }

    const createNewDocument = () => {
        let nameValid = validator.nameValidator(newDocumentname);
        if (!newDocumentname || nameValid !== "") {
            setErrorName(true)
            return
        }

        if (!selectedFile) {
            return
        }

        let today = new Date()
        let dateFormatted = convertToStandarDate(today, language)
        let document = {
            id: 0,
            name: newDocumentname,
            status: 'Generado',
            updatedDate: dateFormatted,
            file: selectedFile,
            url: urlBase64
        }

        let copyDocuments = [...documents]
        copyDocuments.push(document)

        setUrlBase64(selectedFileBase64)
        setErrorName(false)
        setShowPdfLocal(true)
        setDocuments(copyDocuments)
        setDocumentsGrid(copyDocuments)
        handleDeleteFile()
        setNewDocumentName('')
        setShowPdfPrincipal(true)
        setShowModalUpload(false)
    }

    const handleViewDoc = (document) => {
        setPdfURL(document.url)
        let showPdfLocal = (!document.id || document.id === 0) ? true : false
        setShowPdfLocal(showPdfLocal)
    }

    if (isLoadingView) return <div className="standard-wrapper">
        <SimpleLoading />
    </div>

    return (
        <div className="manageAssemblyView-wrapper standard-wrapper">
            <div className="manageAssemblyView-header">
                <HeaderHLPure title={titleHeader} />
            </div>
            <div className="manageAssemblyView-body">
                <div className="manageAssemblyView-container">
                    <div className="manageAssemblyView-grid">
                        {props.statusWorkflow !== 316160 && <div className="manageAssemblyView-btn-add">
                            <ButtonAddHLPure
                                nameBtn={t("manageAssemblyView.btns.add")}
                                iconAdd
                                onClickBtn={() => openModalUpload()}
                            />
                        </div>}
                        <PanelBarGLPure
                            expandedPanel={true}
                            titlePanel={"Documentos"}
                        >
                            <GridSelectionHLPure
                                skip={0}
                                take={6}
                                dataGrid={documentsGrid}

                                columnOne
                                titleRow1={t("manageAssemblyView.grid.title.1")}
                                cellColumnOne={CellColumnOne}
                                headerColumnOne={AllHeadersColumns}
                                headerColumnOneClass={"manageAssemblyView-grid-header1"}
                                // widthColumnOne={widthCellOne}
                                // minResizableWidth1={"auto"}

                                columnTwo={(is820) ? false : true}
                                titleRow2={t("manageAssemblyView.grid.title.2")}
                                cellColumnTwo={CellColumnTwo}
                                headerColumnTwo={AllHeadersColumns}
                                // widthColumnTwo={widthCellTwo}
                                // minResizableWidth2={widthCellTwo}
                                headerColumnTwoClass={"manageAssemblyView-grid-header2"}


                                columnThree={true}
                                titleRow3={t("manageAssemblyView.grid.title.3")}
                                cellColumnThree={CellColumnThree}
                                headerColumnThree={AllHeadersColumns}
                                headerColumnThreeClass={"manageAssemblyView-grid-header3"}
                            // widthColumnThree={widthCellThree}
                            // minResizableWidth3={widthCellThree}
                            />
                        </PanelBarGLPure>
                        <PanelBarGLPure
                            expandedPanel={false}
                            titlePanel={"Miembros de la asamblea"}
                        >
                            <div>
                                <Grid className="validateFreelanceView-headerUsersChat">
                                    <span className="validateFreelanceView-titleGrid">
                                        {t("manageAssemblyView.chat.title")}
                                    </span>
                                    <div className="validateFreelanceView-containersAvatars">
                                        {membersChat.map((item, index) => (
                                            <div>
                                                <Tooltip
                                                    openDelay={600}
                                                    position="bottom"
                                                    anchorElement="target"
                                                    tooltipClassName="tooltipGeneralStyle"
                                                >
                                                    <div>
                                                        <img
                                                            title={item.name}
                                                            key={index}
                                                            src={
                                                                item.avatarUrl && item.avatarUrl !== ""
                                                                    ? item.avatarUrl
                                                                    : newProfileIcon
                                                            }
                                                            className="validateFreelanceView-avatar"
                                                            alt={item.name}
                                                        />
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        ))
                                        }
                                    </div>
                                </Grid>
                                <ChatBoxGLPure
                                    user={usersChat}
                                    conversation={conversation}
                                    widthChat={1200}
                                    heightChat={300}
                                    placeholderChat={t("chatBoxGLPure.placeholder")}
                                    handleInputChange={handleInputChangeChat}
                                    createMessage={createMessage}
                                />
                            </div>
                        </PanelBarGLPure>
                    </div>
                    <div className="manageAssemblyView-pdf">
                        <div className='documentPanelActions-version-pdf'>
                            {
                                showPdfPrincipal && (
                                    (showPdfLocal) ? pdf : pdfAws
                                )

                            }
                        </div>
                        <div className="documentPanelActions-version-pdf-mobile">
                            <DialogPdf blobUrl={blobUrl} />
                        </div>
                    </div>
                </div>
                <div className='manageAssemblyView-buttons'>
                    <ButtonHLPure
                        nameBtn={t("button.back")}
                        onClickBtn={() => handleBackPage()}
                    />
                </div>
            </div>
            <div className='manageAssemblyView-footer'>
                <PromotionalFooterPure />
            </div>
            <DialogSystemGLPure
                showLoadingRequesting={showLoadingRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}

                showCompletedRequesting={showCompletedRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}
                messageComplete={messageComplete}

                showErrorRequesting={showErrorRequesting}
                toggleErrorRequesting={toggleErrorRequestingFalse}
                messageError={messageError}
            />
            {
                showModalUpload && (
                    <DialogPdfHLPure
                        title={t("manageAssemblyView.modal.title")}
                        // description={t("uploadIdentityDocument.modals.upload.description.weight")}
                        canelBtn={t("button.cancel")}
                        saveBtn={t("upload.btn")}
                        width={widthContainerModal}
                        height={heightContainerModal}
                        heightBody={heightBodyModal}
                        cancel={() => closeModalUpload()}
                        handleSubmitProfile={() => handleUploadDocument()}
                    >
                        <div className="manageAssemblyView-modal-body">
                            {!documentSelected &&
                                <InputHLPure
                                    labelInput={t("manageAssemblyView.modal.label.name")}
                                    valueInput={newDocumentname}
                                    inputActive
                                    handleChangeInput={(e) => handleChangeInput(e, setNewDocumentName, setErrorName)}
                                    errorInput={errorName}
                                    errorInputText={t("registration.validator.nameValidator")}
                                    required
                                />
                            }
                            <div className="documentPanelActions-dialog-version-btns">
                                <InputFileHLPure
                                    messageBtn={t("manageAssemblyView.modal.btn.upload")}
                                    flex={true}
                                    acceptFile={"application/pdf"}
                                    selectedFile={selectedFile}
                                    selectedFileName={selectedFileName}
                                    errorFile={errorFile}
                                    handleFile={e => handleFile(e)}
                                    handleDeleteFile={e => handleDeleteFile(e)}
                                />
                            </div>

                            {/*View document*/}
                            {
                                selectedFileBase64 && (
                                    <div className='documentPanelActions-container-pdf'>
                                        <div className='documentPanelActions-version-pdf'>
                                            {pdfModal}
                                        </div>
                                        <div className="documentPanelActions-version-pdf-mobile">
                                            <DialogPdf blobUrl={blobUrl} />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </DialogPdfHLPure>
                )
            }
        </div >
    )
}

export { ManageAssemblyView as default }